import { createSlice } from '@reduxjs/toolkit';

export const servicesIaUsageDailysSlice = createSlice({
  name: 'servicesIaUsageDailys',
  initialState: {
    services_ia_usage_dailys_list: [],
    services_ia_usage_dailys: {},
    customers_for_select: [],
  },
  reducers: {
    setServicesIaUsageDailysListRedux: (state, { payload }) => {
      state.services_ia_usage_dailys_list = payload;
    },
    setServicesIaUsageDailysRedux: (state, { payload }) => {
      state.services_ia_usage_dailys = payload;
    },
    setCustomersForSelectRedux: (state, { payload }) => {
      state.customers_for_select = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setServicesIaUsageDailysListRedux,
  setServicesIaUsageDailysRedux,
  setCustomersForSelectRedux,
} = servicesIaUsageDailysSlice.actions;
